import { isDirectConsumptionItem } from "../components/itemsFamiliesUi";

// Use the effective policy supplied by the API; the shared resolver also handles
// inherited policies on locally selected items and the stockable default.
export function supportsExpirationDate(item, line) {
  const source = item?.inventory_policy_effective ? item
    : line?.inventory_policy_effective ? line : item || line;
  return Boolean(source) && source.inventory_policy_is_direct_consumption !== true && !isDirectConsumptionItem(source);
}

export function expirationDateValue(value) {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value) || value.startsWith("0000-")) return "";
  const date = new Date(`${value}T00:00:00.000Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value ? value : "";
}

export function expirationDatePayload(line, item) {
  return supportsExpirationDate(item, line) ? expirationDateValue(line?.expiration_date) || null : null;
}
